// Geo + open-now helpers
const R_KM = 6371;
const toRad = (d) => (d * Math.PI) / 180;
const MI_PER_KM = 0.621371;
const WALK_M_PER_MIN = 80;

export function haversineKm(a, b) {
  if (!a || !b || a.lat == null || a.lng == null || b.lat == null || b.lng == null) return null;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const la = toRad(a.lat);
  const lb = toRad(b.lat);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(la) * Math.cos(lb) * Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  return R_KM * c;
}

export function fmtDistance(km) {
  if (km == null || !Number.isFinite(km) || km >= 50) return null;
  if (km < 1) return `${Math.round(km * 1000)} m`;
  return `${km.toFixed(1)} km`;
}

/**
 * Format full distance + walking time:
 *   - <1km: "350 m · 0.2 mi · 4 min walk"
 *   - >=1km: "1.2 km · 0.7 mi · 15 min walk"
 * Walking speed assumption: 80 m/min, rounded to nearest minute, min 1.
 *
 * iter134 — Returns null when distance is null/non-finite/>=50km. This
 * prevents the UI from rendering nonsense like "407.2 km · 5090 min walk"
 * when GPS is unavailable or coordinates are bad.
 */
export function fmtDistanceWalk(km) {
  if (km == null || !Number.isFinite(km) || km >= 50) return null;
  const meters = km * 1000;
  const dist = km < 1 ? `${Math.round(meters)} m` : `${km.toFixed(1)} km`;
  const miles = (km * MI_PER_KM).toFixed(1);
  const mins = Math.max(1, Math.round(meters / WALK_M_PER_MIN));
  return `${dist} · ${miles} mi · ${mins} min walk`;
}

/** Walking minutes only (rounded, min 1). Returns null if km is null or
 *  beyond the 50km plausibility threshold. */
export function walkMinutes(km) {
  if (km == null || !Number.isFinite(km) || km >= 50) return null;
  return Math.max(1, Math.round((km * 1000) / WALK_M_PER_MIN));
}

export function openNowBadge(b) {
  if (b?.open_now) return { key: "open", label: "Open now" };
  if (b?.here_tonight) return { key: "tonight", label: "Here tonight" };
  return { key: "closed", label: "Closed" };
}

export function categoryLabel(cat) {
  return ({
    cigar_lounge: "Cigar Lounge",
    rooftop: "Rooftop",
    bar: "Bar",
    restaurant: "Restaurant",
    shop: "Cigar Shop",
    club: "Nightlife",
    hotel: "Hotel",
    beach: "Beach",
    local_gem: "Local Gem",
    other: "Other",
  })[cat] || cat;
}

// iter152 — CATEGORY_CHIPS is now derived from lib/categories.js
// (single source of truth for the 12 canonical Level-1 categories).
// The re-export preserves the legacy import path so no consumer needs
// a rewrite.
export { CATEGORY_CHIPS } from "./categories";
